import React from 'react';
import PropTypes from 'prop-types';
import { createElementClassName } from '../utils/expandableUtils';

/**
 * Reusable title component for expandable sections
 */
const ExpandableTitle = ({
  baseClassName,
  name,
  icon,
  onClick,
}) => {
  if (name=== null || name=== undefined) return null;

  // With icon
  if (icon) {
    return (
      <div className={createElementClassName(baseClassName, 'usericon_container')}>
        <img 
          className={createElementClassName(baseClassName, 'usericon')} 
          src={icon} 
          alt={name}
        />
        <span 
          className={createElementClassName(baseClassName, 'name')} 
          onClick={onClick}
        >
          {name}
        </span>
      </div>
    );
  }

  // Without icon
  return (
    <span 
      className={createElementClassName(baseClassName, 'name')} 
      onClick={onClick}
    >
      {name}
    </span>
  );
};

ExpandableTitle.propTypes = {
  baseClassName: PropTypes.string.isRequired,
  name: PropTypes.string,
  icon: PropTypes.string,
  onClick: PropTypes.func,
};

export default ExpandableTitle;



// WEBPACK FOOTER //
// ./src/components/ExpandableSection/components/ExpandableTitle.js